import { TextView } from '@dreryk/react-components';
import { createTranslatedText, Translate } from '@dreryk/react-common';

import { translationKeys } from '../translations';
import { PaymentMethodType } from '../types';

const EMPTY_PLACEHOLDER = '-';

type AdvancePaymentSurchargeMethodTypeTextViewProps = Readonly<{ surchargeMethodType: PaymentMethodType | undefined }>;

export const AdvancePaymentSurchargeMethodTypeTextView = (
   props: AdvancePaymentSurchargeMethodTypeTextViewProps
): JSX.Element => {
   return (
      <TextView testId={'advancePaymentSurchargeMethodType'} label={translationKeys.advancePaymentSurchargeMethodType}>
         <Translate>
            {props.surchargeMethodType
               ? translationKeys.paymentMethodTypeMap[props.surchargeMethodType]
               : createTranslatedText(EMPTY_PLACEHOLDER)}
         </Translate>
      </TextView>
   );
};
